export enum HtmlCssClass {
    WidgetContainer = "widget-html-container",
    WidgetContent = "widget-html-content",
    WidgetFooter = "widget-html-footer",
    PdfView = "pdf-view"
}